import { makeAutoObservable } from 'mobx';
import { RsValue } from '../../models/base/BaseModel';
import { RegisterRequest, RegisterResponse } from '../../models/user/UserModels';
import { userService } from '../../services/user.service';
import { RootStore } from '../RootStore';

class UserStore {
  rootStore: RootStore;
  error: string | null = null;

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
    makeAutoObservable(this);
  }
  register = async (data: RegisterRequest): Promise<RsValue<RegisterResponse>> => {
    this.error = null;
    try {
      const response: RsValue<RegisterResponse> = await userService.register(data);
      this.error = response.error ? response.message : null;
      return response;
    } catch (error) {
      const errorResponse: RsValue<RegisterResponse> = {
        error: true,
        message: 'Kayıt işlemi sırasında bir hata oluştu',
        statusCode: 500,
        value: null,
      };
      this.error = errorResponse.message;
      return errorResponse;
    }
  };
  clearError = () => {
    this.error = null;
  };
}

export default UserStore;
